import React from "react";
import { Form, Label, Radio } from "semantic-ui-react";

const RadioInput = ({
  input,
  width,
  label,
  meta: { touched, error },
  handleOnChange,
  checked,
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <Radio
        value={input.value}
        label={label}
        onChange={(e, data) => {
          input.onChange(data.value);
          if (handleOnChange) handleOnChange(data.value);
        }}
        onBlur={(e, data) => input.onBlur(data)}
        checked={checked}
        className="radioInput"
      />
      {touched && error && (
        <Label pointing basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default RadioInput;
